import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import SectionHeading from "../components/SectionHeading";
import { partnerBenefits, partners, supportOptions } from "../data/partners";
import { useSeo } from "../hooks/useSeo";

export default function PartnersPage() {
  useSeo({
    title: "Partners | Em Whell Motorsport",
    description: "Partner with Em Whell Motorsport for trackside exposure, social media reach and driver appearances with the #7 SSA Production Sedan.",
    path: "/partners",
    image: "/assets/promo-car.jpg",
  });

  return (
    <>
      <PageHero
        eyebrow="Partnerships"
        title="Put your brand"
        highlight="in the action."
        copy="Create genuine, visible and memorable connections with motorsport audiences across Queensland and beyond."
        image="/assets/promo-car.jpg"
        imageWidth={1080}
        imageHeight={1080}
      />
      <section className="section">
        <div className="site-container partner-intro-grid">
          <Reveal>
            <p className="eyebrow">Partner with Em</p>
            <h2>
              More than a logo <span>on a car.</span>
            </h2>
          </Reveal>
          <Reveal>
            <p className="lead">
              A partnership with Em Whell Motorsport is more than branding, it's
              becoming part of a journey. From race weekends and social media to
              community events and business promotions, your brand is
              represented by someone who genuinely values every opportunity and
              every supporter.
            </p>
            <p className="muted">
              Every partnership can be tailored to suit your goals, from logo
              placement and social media promotion to driver appearances,
              promotional events and race-day experiences. Whether you're a
              local business or an established brand, every partnership is built
              on communication, professionalism and genuine appreciation.
            </p>
          </Reveal>
        </div>
        <div className="site-container benefit-grid">
          {partnerBenefits.map((benefit, index) => (
            <Reveal key={benefit}>
              <article>
                <span>{String(index + 1).padStart(2, "0")}</span>
                <h3>{benefit}</h3>
              </article>
            </Reveal>
          ))}
        </div>
      </section>
      <section className="partnership-callout">
        <img
          src="/assets/em-car-night.jpg"
          alt="Em Whell beside the number 7 race car"
          width="1080"
          height="810"
          loading="lazy"
        />
        <div>
          <Reveal>
            <p className="eyebrow">Appearances and displays</p>
            <h2>
              Bring the #7 <span>to your business.</span>
            </h2>
            <p>
              The race car and driver can be made available for openings, expos,
              promotions, displays and community events — creating a memorable
              customer experience and valuable branded content.
            </p>
            <Link className="button button-primary" to="/contact">
              Enquire about an appearance
            </Link>
          </Reveal>
        </div>
      </section>
      <section className="section">
        <div className="site-container">
          <SectionHeading
            eyebrow="Current partners"
            title="The businesses behind"
            highlight="the journey."
          />

          {partners.length ? (
            <>
              <div className="partner-logo-grid">
                {partners.map((partner) => (
                  <a
                    key={partner.name}
                    href={partner.url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={"/assets/partners/" + partner.logo}
                      alt={partner.name}
                      width="800"
                      height="155"
                      loading="lazy"
                    />
                  </a>
                ))}
              </div>

              <div className="partner-placeholder">
                <strong>Join the team.</strong>
                <p>
                  Becoming a partner means more than just putting your logo on a race car. It's about creating opportunities for your business to stand out, connect with new audiences and build lasting relationships.
                </p>
                <Link className="button button-primary" to="/contact">
                  Start a conversation
                </Link>
              </div>
            </>
          ) : (
            <div className="partner-placeholder">
              <strong>Your brand could be here.</strong>
              <p>
                Partnership opportunities are now available for the 2026/27
                season. Let's build something great together.
              </p>
              <Link className="button button-primary" to="/contact">
                Start a conversation
              </Link>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
